import { SelectOption } from '@/types/form.type.ts';

export enum FeedbackCategory {
    Auth = 'auth',
    Cars = 'cars',
    Auctions = 'auctions',
    Reports = 'reports',
    Others = 'others',
}

export function getFeedbackCategoryLabel(category: FeedbackCategory): string {
    switch (category) {
        case FeedbackCategory.Auth:
            return 'Регистрация и доступ в систему';
        case FeedbackCategory.Cars:
            return 'Работа с автомобилями';
        case FeedbackCategory.Auctions:
            return 'Проведение аукционов';
        case FeedbackCategory.Reports:
            return 'Документы и отчеты';
        case FeedbackCategory.Others:
            return 'Технические неисправности и ошибки';
    }
}

export function getFeedbackCategorySelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(FeedbackCategory).forEach((category: FeedbackCategory) => {
        options.push({
            label: getFeedbackCategoryLabel(category),
            value: category,
        });
    });

    return options;
}
